import React from 'react';
import { FaEye, FaBullseye, FaGem } from 'react-icons/fa';

const Mission = () => {
  return (
    <section className="py-16 sm:py-20 px-6 sm:px-8 lg:px-12 bg-white min-h-screen flex items-center">
      <div className="max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Vision Card */}
          <div className="bg-white border border-gray-200 rounded-3xl shadow-lg p-8 flex flex-col items-center text-center transition-all hover:shadow-xl">
            <div className="bg-gradient-to-br from-orange-100 to-pink-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
              <FaEye className="text-orange-400 text-4xl" />
            </div>
            <h3 className="text-2xl font-semibold mb-4 text-gray-900">VISION</h3>
            <p className="text-gray-600 font-light leading-relaxed">
              To pioneer innovation at the intersection of technology and creativity, empowering Cyborgsapient Pvt Ltd to solve complex customer challenges and drive sustainable growth.
            </p>
          </div>

          {/* Mission Card */}
          <div className="bg-white border border-gray-200 rounded-3xl shadow-lg p-8 flex flex-col items-center text-center transition-all hover:shadow-xl">
            <div className="bg-gradient-to-br from-pink-100 to-purple-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
              <FaBullseye className="text-pink-400 text-4xl" />
            </div>
            <h3 className="text-2xl font-semibold mb-4 text-gray-900">MISSION</h3>
            <p className="text-gray-600 font-light leading-relaxed">
              We aim to continuously innovate and deliver solutions that exceed expectations. Through strong marketing and a growth mindset, we support both customer and team success while contributing to society.
            </p>
          </div>

          {/* Values Card */}
          <div className="bg-white border border-gray-200 rounded-3xl shadow-lg p-8 flex flex-col items-center transition-all hover:shadow-xl">
            <div className="bg-gradient-to-br from-purple-100 to-pink-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
              <FaGem className="text-purple-400 text-4xl" />
            </div>
            <h3 className="text-2xl font-semibold mb-6 text-gray-900">VALUES</h3>
            <ul className="text-gray-600 text-base space-y-3 text-left w-full">
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-gradient-to-r from-orange-400 to-pink-400 rounded-full"></span>
                <span className="font-light">Integrity</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full"></span>
                <span className="font-light">Respect</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full"></span>
                <span className="font-light">Growth Mindset</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-gradient-to-r from-orange-400 to-pink-400 rounded-full"></span>
                <span className="font-light">Value Creation</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-2 h-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full"></span>
                <span className="font-light">Societal Contribution</span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Mission;
